const styles = theme => ({
  MuiButton: {
    label: {
      color: ["white", "!important"]
    }
  },
  tableContainer: {
    margin: theme.spacing(6),
    borderTop: "4px solid" + theme.palette.alt.main
  },

  tableCellContainer: {
    position: "relative"
  },
  arrowIcon: {
    position: "absolute",
    right: 0
  },

  titleButtonContainer: {
    marginRight: theme.spacing(6),
    marginLeft: theme.spacing(6)
  },
  titleContainer: {
    marginTop: theme.spacing(4)
  },

  searchBar: {
    backgroundColor: theme.palette.secondary.light,
    marginLeft: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  searchIcon: {
    color: "black",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    top: 6,
    position: "relative"
  },
  searchInput: {
    fontSize: 14
  },
  sortContianer: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    paddingRight: theme.spacing(1)
  },
  informationCells: {
    height: "110px"
  },

  cellBackgroundGray: {
    backgroundColor: "#F6F6F6"
  },
  orgNameContainer: {
    color: theme.palette.alt.main
  },
  paginationContainer: {
    marginTop: theme.spacing(6)
  },
  deleteButton: {
    marginLeft: theme.spacing(2),
    color: "white",
    backgroundColor: "red",
    "&:hover": {
      backgroundColor: "red"
    }
  },
  closeButton: {
    color: [theme.palette.primary.default, "!important"]
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/pages/SuperAdmin/styles.js